/* Live tenant user directory (id -> name). Populated once by OpsLayout from the
   `usersDirectory` GraphQL query (available to any authenticated role) so every
   module can render a person's name instead of a raw user UUID. Mirrors the
   productById / locationById registry pattern. */

export interface UserSummary {
  id: string
  displayName?: string | null
  email?: string | null
}

export let users: UserSummary[] = []

export function setUserDirectory(next: UserSummary[]): void {
  users = next
}

export const userById = (id?: string | null): UserSummary | undefined =>
  id ? users.find((u) => u.id === id) : undefined

/** Human-readable name for a user id: displayName, then email, else undefined. */
export const userNameById = (id?: string | null): string | undefined => {
  const u = userById(id)
  return u ? u.displayName || u.email || undefined : undefined
}
